<template>
  <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
    <b-modal
      v-model="modalAberto"
      title="Observações"
      size="lg"
      header-bg-variant="secondary"
      header-text-variant="light"
      @hide="closeModal"
      centered
    >
      <b-form @submit.prevent="handleSubmit(salvarObs)">
        <b-container>
          <b-row>
            <b-col cols="12">
              <default-form-validation-provider
                v-slot="defaultState"
                label="Endereço URL"
              >
                <b-input-group>
                  <b-form-input
                    v-model="linkEvidencia"
                    type="url"
                    placeholder="https://example.com"
                    :state="defaultState.state"
                    :disabled="disabled"
                  />
                  <b-button @click="acessarUrl">Acessar</b-button>
                </b-input-group>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
              <default-form-validation-provider label="Justificativa">
                <b-form-textarea
                  rows="5"
                  max-rows="5"
                  v-model="justificativa"
                  :state="justificativa.length <= 500"
                  autofocus
                  :disabled="disabled"
                />
              </default-form-validation-provider>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="closeModal">{{
          disabled ? "Fechar" : "Cancelar"
        }}</b-button>
        <b-button
          v-if="!disabled"
          size="sm"
          variant="secondary"
          type="submit"
          @click="salvarObs"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { AtributoSerigy } from "@/types/administracao/serigy/atributo-serigy";
import { EnumTipoAnaliseId } from "@/types/administracao/serigy/enum-tipo-analise-id";
import { RespostaDetalheSerigy } from "@/types/administracao/serigy/resposta-detalhe-serigy";

@Component({
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
  },
})
export default class ModalObservacaoSerigy extends mixins(UtilsTS, Vue) {
  @Prop({ required: true }) atributo!: AtributoSerigy;
  @Prop({ required: true }) disabled!: boolean;

  modalAberto = true;
  justificativa = "";
  linkEvidencia = "";

  async salvarObs() {
    try {
      const novoAtributo = new AtributoSerigy(this.atributo);
      if (novoAtributo.temRespostaAuditor) {
        const indexAuditor = novoAtributo.respostas.findIndex(
          (r) => r.tipoAnaliseId === EnumTipoAnaliseId.AUDITOR
        );
        novoAtributo.respostas.splice(indexAuditor, 1);
      }
      novoAtributo.respostas.push(
        new RespostaDetalheSerigy({
          criterioAtributoId: this.atributo.respostas[0].criterioAtributoId,
          tipoAnaliseId: EnumTipoAnaliseId.AUDITOR,
          cpfAuditor: null,
          linkEvidencia: this.linkEvidencia,
          txtAnalise: this.justificativa,
          ponto: this.atributo.pontoGeral,
          dhResposta: null,
          linkPrint: this.atributo.respostas[0].linkPrint ?? null,
        })
      );
      this.$emit("atualiza", novoAtributo);
      this.closeModal();
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  acessarUrl() {
    if (this.linkEvidencia) window.open(this.linkEvidencia, "_blank");
    else this.$toast.error("Nenhum link de evidência disponível.");
  }

  closeModal() {
    this.$emit("close");
  }

  mounted() {
    const repostaAuditor = this.atributo.respostas.find(
      (r) => r.linkEvidencia && r.tipoAnaliseId === EnumTipoAnaliseId.AUDITOR
    );
    const repostaBot = this.atributo.respostas.find(
      (r) => r.linkEvidencia && r.tipoAnaliseId === EnumTipoAnaliseId.BOT
    );
    const reposta = repostaAuditor ?? repostaBot;
    this.linkEvidencia = reposta?.linkEvidencia ?? "";
    this.justificativa = reposta?.txtAnalise ?? "";
  }
}
</script>
